var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasLaeqData)?_c('l-marker',{attrs:{"lat-lng":_vm.position,"icon":_vm.laeqIcon,"zIndexOffset":1000},on:{"click":_vm.handleClick}}):_c('l-marker',{attrs:{"lat-lng":_vm.position,"icon":_vm.customIcon},on:{"click":_vm.handleClick}},[_c('l-tooltip',{attrs:{"content":_vm.label}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }